export default "__VITE_ASSET__B6$Sq9xp__"